import { QuizletResultsDto } from '@/api/generated/model/quizletResultsDto';
import MarkdownText from '@/components/markdown/markdown-text';
import { Box, IconCheck } from '@cmpsr/components';

export function CircleCheckBullet({ children }: { children: string }) {
  return (
    <Box display="flex" alignItems="center" gap="spacer-2">
      <Box
        backgroundColor="green"
        borderRadius="50%"
        width="24px"
        height="24px"
        display="flex"
        alignItems="center"
        justifyContent="center"
        flexShrink={0}
        flexGrow={0}
      >
        <IconCheck color="dark-blue" size="s" data-testid="icon-check" />
      </Box>
      <MarkdownText fontSize={{ base: '1rem', lg: '1.25rem' }} lineHeight="130%">
        {children}
      </MarkdownText>
    </Box>
  );
}

// Generic marketing messages to show when personalized messages aren't available
export const marketingMessages = [
  '**Early detection** can increase cancer survival rates by up to 90%.',
  'Catch helps you understand your **unique risk profile** for 21 different cancers.',
  '**Personalized screening plans** can help catch cancer at its most treatable stage.',
  'Up to **40% of cancers** are preventable through lifestyle changes.',
  'Catch provides **actionable insights** to help reduce your cancer risk.',
];

export function PersonalizedList({ results }: { results?: QuizletResultsDto }) {
  // Always display something - personalized messages if available, otherwise marketing messages
  const messagesToDisplay =
    results?.personalizedMessages && results.personalizedMessages.length > 0
      ? results.personalizedMessages
      : marketingMessages;

  return (
    <Box display="flex" flexDirection="column" gap="spacer-4">
      {messagesToDisplay.map((message, index) => (
        <CircleCheckBullet key={index}>{message}</CircleCheckBullet>
      ))}
    </Box>
  );
}
